import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { InjectionToken, NgModule } from "@angular/core";
import { CoreCommonModule } from "moo-vuexy-core";
import { AuthenticationApiService } from "./authentication/authentication-api.service";
import { AuthenticationServerService } from "./authentication/authentication-server.service";
import { IpTokenService } from "./authentication/iptoken.service";
import { OidcService } from "./authentication/oidc.service";
import { ResourceApiService } from "./authentication/resource-api.service";
import { EnvironmentService } from "./environment.service";
import { HttpErrorHandlerService, HttpErrorNotifier, HttpResponse5xErrorInterceptor } from "./http-response-interceptor.service";
import { LoadingSpinnerComponent } from "./loading-spinner/loading-spinner.component";
import { LoadingSpinnerModule } from "./loading-spinner/loading-spinner.module";
import { LoginTranslationModule } from "./translation/translation.module";
import {provideCoolShared} from "cool-shared";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";


export const TRANSLATION_CONFIG = new InjectionToken<string>("TranslationConfig");

@NgModule({
  declarations: [],
  exports: [
    LoadingSpinnerComponent,
    LoginTranslationModule
  ], imports: [CoreCommonModule,
    LoginTranslationModule,
    LoadingSpinnerModule,
    BrowserAnimationsModule], providers: [
    OidcService,
    AuthenticationApiService,
    AuthenticationServerService,
    EnvironmentService,
    ResourceApiService,
    IpTokenService,
    HttpErrorHandlerService,
    HttpErrorNotifier,
    { provide: HTTP_INTERCEPTORS, useClass: HttpResponse5xErrorInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    provideCoolShared()
  ]
})
export class AuthenticationCoreModule {
}
